import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";
import { HOME } from "@/constants/testIds";
import { SPOTIFY_URL, TAGLINE } from "@/lib/constants";

const fade = (delay) => ({
    initial: { opacity: 0, y: 14 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, delay, ease: [0.22, 0.61, 0.36, 1] },
});

export const Hero = () => (
    <section id="top" data-testid={HOME.hero} className="border-b border-[var(--rule)]">
        <div className="mx-auto max-w-[1240px] px-6 sm:px-10 lg:px-16 pt-14 pb-20 sm:pt-20 sm:pb-24 lg:pt-24 lg:pb-32">
            <div className="grid gap-12 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:gap-16 lg:items-center">
                <div>
                    <motion.div {...fade(0)} data-testid={HOME.heroLogo} className="lg:hidden">
                        <Logo size={132} className="sm:hidden" />
                        <Logo size={168} className="hidden sm:block" decorative />
                    </motion.div>

                    <motion.h1
                        {...fade(0.1)}
                        data-testid={HOME.heroTitle}
                        className="font-display mt-9 lg:mt-0 text-[15vw] leading-[0.88] sm:text-[10.5vw] lg:text-[6.6rem] xl:text-[7.4rem]"
                    >
                        deep end{" "}
                        <br />
                        grooves
                    </motion.h1>

                    <motion.p
                        {...fade(0.2)}
                        data-testid={HOME.heroTagline}
                        className="font-italic-serif mt-6 sm:mt-8 text-2xl sm:text-3xl lg:text-[2.5rem] text-[var(--terracotta-ink)]"
                    >
                        {TAGLINE}
                    </motion.p>

                    <motion.p
                        {...fade(0.3)}
                        data-testid={HOME.heroLane}
                        className="prose-body mt-8 sm:mt-10 max-w-[52ch] text-base sm:text-lg lg:text-xl text-[var(--ink)] opacity-85"
                    >
                        A listening project maintained by an anonymous curator that would rather keep the spotlight on
                        the records. Deep house, deep tech, dub techno, dub lounge — selected by hand, old and new.
                    </motion.p>

                    <motion.div {...fade(0.4)} className="mt-10 flex flex-col items-start gap-5">
                        <a
                            href={SPOTIFY_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={HOME.heroSpotifyCta}
                            className="border border-[var(--ink)] bg-[var(--ink)] px-7 py-4 text-sm sm:text-base font-bold uppercase tracking-[0.08em] text-[var(--cream)] hover:bg-[var(--terracotta-ink)] hover:border-[var(--terracotta-ink)] transition-colors duration-200"
                        >
                            follow the playlist on spotify
                        </a>
                        <a
                            href="#submit"
                            data-testid={HOME.heroSubmitLink}
                            className="eyebrow border-b border-[var(--ink)] pb-1 hover:text-[var(--terracotta-ink)] hover:border-[var(--terracotta-ink)] transition-colors duration-200"
                        >
                            or submit a track
                        </a>
                    </motion.div>
                </div>

                <motion.div {...fade(0.15)} className="hidden lg:flex justify-end">
                    <Logo size={380} className="xl:hidden" />
                    <Logo size={440} className="hidden xl:block" decorative />
                </motion.div>
            </div>
        </div>
    </section>
);
